import tw from 'twin.macro'
import React from 'react'
import * as DialogPrimitive from '@radix-ui/react-dialog'

import { Button } from 'common/components/Button/Button'
import { useDialog } from '../Dialog/hooks/useDialog'

const defaultTitleText = 'Are you sure?'
const defaultCreateBtnText = 'Create'
const defaultCancelBtnText = 'Cancel'

export function CreateDialogBanner({
  titleText = defaultTitleText,
  createBtnText = defaultCreateBtnText,
  cancelBtnText = defaultCancelBtnText,
  text,
  subtext,
  handleCreate,
  handleCancel,
  loading = false,
  children,
  descriptionClassNames = 'max-w-xs mx-auto text-center',
}) {
  const [, setDialogOpen] = useDialog()

  const onCreate = async () => {
    await handleCreate()
    setDialogOpen(false)
  }

  const onCancel = async () => {
    if (handleCancel) {
      await handleCancel()
    }
    setDialogOpen(false)
  }

  return (
    <div className='px-10 pt-14 pb-8'>
      {titleText && (
        <DialogPrimitive.Title className='font-bold text-2xl text-tBlack text-center mb-4'>
          {titleText}
        </DialogPrimitive.Title>
      )}
      <DialogPrimitive.Description className={`text-tBlack mb-6 ${descriptionClassNames}`}>
        <span className='block'>{text}</span>
        {subtext && <span className='block'>{subtext}</span>}
      </DialogPrimitive.Description>
      {children}
      <div className='flex-1 flex items-center'>
        <Button variant='secondary' css={tw`flex-1`} onClick={onCancel}>
          {cancelBtnText}
        </Button>
        <Button onClick={onCreate} loading={loading} css={tw`flex-1 ml-4`}>
          {createBtnText}
        </Button>
      </div>
    </div>
  )
}
